<template>
  <div class="layer mobilityInfo">
    <div class="inner">
      <button type="button" class="btnClose" @click.stop="cancel"><span class="blind">close</span></button>
      <div class="layerTitle toCapitalize">{{locale.mobility_call_info}}</div>
      <p v-if="isDirect" class="mb30 toCapitalize">{{locale.mobility_call_info_title_no_destination}}<br>{{locale.mobility_call_info_title_2}}</p>
      <p v-else class="mb30 toCapitalize">{{locale.mobility_call_info_title_1}}<br>{{locale.mobility_call_info_title_2}}</p>
      <div v-if="waypoint" class="formGroup">
        <p class="label colorGrey toCapitalize">{{locale.mobility_waypoint}}</p>
        <div
          v-for="(item, index) in waypoint"
          :key="index"
          class="mt5">
          {{ item }}
        </div>
      </div>
      <div v-if="!isDirect" class="formGroup">
        <p class="label colorGrey toCapitalize">{{locale.mobility_destination}}</p>
        <div class="mt5">
          {{ destinationAddress }}
        </div>
      </div>
      <div class="formGroup">
        <p class="label colorGrey toCapitalize">{{ locale.telephone }}</p>
        <div class="telInputWithSearch notranslate mt5">
          <!-- <input type="tel" class="input" v-model="phone"> -->
          <div v-show="openCountry" class="searchCountry">
            <input
              type="text"
              class="input"
              placeholder="country name or code"
              ref="searchInput"
              v-model="searchCountry"
              @focus.stop
              @click.stop
              @keyup.enter="setSearchCountry" />
            <button type="button" class="btn btnPrimary btnSearch" @click.stop="setSearchCountry">
              {{locale.search}}
            </button>
          </div>
          <vue-tel-input
            class="telInput input"
            ref="telInput"
            :mode="'national'"
            :autoDefaultCountry="true"
            :preferredCountries="filteredCountry"
            :validCharactersOnly="true"
            v-model="phone"
            @input="inputTel"
            @open="toggleCountry(true)"
            @close="toggleCountry(false)"></vue-tel-input>
        </div>
      </div>
      <div class="btns">
        <button type="button" class="btn btnWhite toCapitalize" @click="cancel">{{ locale.cancel }}</button>
        <button type="button" class="btn toCapitalize" :disabled="!validatePhone.valid" @click="confirmPhoneInfo">{{ locale.confirm }}</button>
      </div>
    </div>
    <div v-if="toastList">
      <Toast v-for="toast in toastList"
        :locale="locale"
        :key="toast.id"
        :toast="toast"
        @confirm="toastConfirm" />
    </div>
  </div>
</template>

<script>
import regExp from '@/common/regExp'
import UNIQUE from '@/common/unique'
import Toast from '@/components/Util/Toast'

export default {
  name: 'MobilityInfo',
  props: [
    'locale',
    'isDirect', // 목적지 없이 호출
    'phoneNumber',
    'destinationAddress',
    'waypoint'
  ],
  components: {
    Toast
  },
  computed: {
    filteredCountry () {
      const word = regExp.replaceAllEmpty(this.searchCountry).toLowerCase()
      const findCountry = this.countryList.filter(x => {
        const iso2 = regExp.replaceAllEmpty(x.iso2).toLowerCase().includes(word)
        const dialCode = regExp.replaceAllEmpty(`+${x.dialCode}`).toLowerCase().includes(word)
        const name = regExp.replaceAllEmpty(x.name).toLowerCase().includes(word)
        return word.length > 0 && (iso2 || dialCode || name)
      }).map(x => x.iso2)
      return findCountry
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.countryList = this.$refs.telInput ? this.$refs.telInput.allCountries : []
    })
  },
  data () {
    let phone = this.phoneNumber || ''
    return {
      searchCountry: '',
      openCountry: false,
      countryList: [],
      validatePhone: {},
      phone,
      toastList: []
    }
  },
  methods: {
    setSearchCountry () {
      const value = this.$refs.searchInput.value
      this.searchCountry = value
    },
    toggleCountry (isOpen) {
      this.openCountry = isOpen
      if (isOpen) {
        const findInput = this.$refs.searchInput
        if (findInput) {
          this.$nextTick(() => findInput.focus())
        }
      }
    },
    inputTel (number, telObj) {
      this.validatePhone = telObj
      // this.phone = telObj.number
    },
    addToast (trigger, type, message, otherData) {
      const id = UNIQUE.mid()
      const toast = {
        id: id,
        type: type,
        trigger: trigger,
        message: message,
        ...otherData
      }
      this.toastList.push(toast)
    },
    delToast (id) {
      this.toastList = id ? this.toastList.filter(x => x.id !== id) : []
    },
    toastConfirm (data) {
      const trigger = this.toastList.find(x => x.id === data.id) ? this.toastList.find(x => x.id === data.id).trigger : null
      if (!data.isConfirm) {
        this.delToast(data.id)
      } else {
        if (trigger) {
          if (trigger === 'closeToast') {
            this.delToast()
          } else if (trigger === 'confirmInfo') {
            this.confirm()
          }
        } else {
          alert(this.locale.alert_system_error)
          this.delToast()
        }
      }
    },
    confirmPhoneInfo () {
      this.addToast('confirmInfo', 'confirm', this.locale.confirm_phone_correct, { emMessage: `${this.validatePhone.formatted}\n(${this.validatePhone.number})` })
    },
    cancel () {
      this.$emit('cancel')
    },
    confirm () {
      this.$emit('confirm', this.validatePhone.number)
    }
  }
}
</script>

<style lang="scss" scoped>
.formGroup {
  .label {
    font-size: 14px;
  }
}
</style>
